import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push, get, ref } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };

  const getDriverFleetAdmin = async (driverUid) => {
    if (!driverUid) {
      return null;
    }
    const { singleUserRef } = firebase;
    const driverSnapshot = await get(singleUserRef(driverUid));
    const driver = driverSnapshot.val();
    return driver && driver.fleetadmin ? driver.fleetadmin : null;
  };

  export const syncDriverCarsFleetAdmin = (driverUid, fleetadmin) => async () => {
    if (!driverUid) {
      return { updated: 0, skipped: 0 };
    }
    const { database, carEditRef } = firebase;
    const carsSnapshot = await get(ref(database, "cars"));
    const cars = carsSnapshot.val();
    let updated = 0;
    let skipped = 0;

    if (!cars) {
      return { updated, skipped };
    }

    await Promise.all(
      Object.keys(cars).map(async (carId) => {
        const car = cars[carId];
        if (!car || car.driver !== driverUid) {
          skipped++;
          return;
        }
        const nextFleetAdmin = fleetadmin || null;
        if ((car.fleetadmin || null) === nextFleetAdmin) {
          skipped++;
          return;
        }
        await update(carEditRef(carId), { fleetadmin: nextFleetAdmin });
        updated++;
      })
    );

    console.log("Car fleetadmin sync completed", { driverUid, updated, skipped });
    return { updated, skipped };
  };

  export const syncAllCarFleetAdminOwnership = () => async () => {
    const { database, singleUserRef, carEditRef } = firebase;
    const carsSnapshot = await get(ref(database, "cars"));
    const cars = carsSnapshot.val();
    let updated = 0;
    let skipped = 0;

    if (!cars) {
      console.log("Car fleetadmin backfill completed", { updated, skipped });
      return { updated, skipped };
    }

    await Promise.all(
      Object.keys(cars).map(async (carId) => {
        const car = cars[carId];
        if (!car || !car.driver) {
          skipped++;
          return;
        }
        const driverSnapshot = await get(singleUserRef(car.driver));
        const driver = driverSnapshot.val();
        if (!driver || !driver.fleetadmin) {
          skipped++;
          return;
        }
        if (car.fleetadmin === driver.fleetadmin) {
          skipped++;
          return;
        }
        await update(carEditRef(carId), { fleetadmin: driver.fleetadmin });
        updated++;
      })
    );

    console.log("Car fleetadmin backfill completed", { updated, skipped });
    return { updated, skipped };
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        const fleetadmin = await getDriverFleetAdmin(car.driver);
        push(carAddRef, { ...car, fleetadmin: fleetadmin || null });
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        const fleetadmin = await getDriverFleetAdmin(car.driver);
        set(carEditRef(car.id), { ...car, fleetadmin: fleetadmin || null });
    }
  }

  export const updateUserCarWithImage = (newData, blob) => async (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage
    } = firebase;

    var carId = push(carAddRef).key;
    const driverUid = newData.driver || (auth.currentUser && auth.currentUser.uid);
    const fleetadmin = await getDriverFleetAdmin(driverUid);
    const carData = { ...newData, fleetadmin: fleetadmin || null };

    uploadBytesResumable(carImage(carId),blob).then(() => {
      blob.close()
      return getDownloadURL(carImage(carId))
    }).then((url) => {
      carData.car_image = url;
      set(child(carAddRef, carId),carData )
      if(carData.active){
        let updateData = {
          carType: carData.carType,
          vehicleNumber: carData.vehicleNumber,
          vehicleMake: carData.vehicleMake,
          vehicleModel: carData.vehicleModel,
          other_info: carData.other_info,
          car_image:url,
          carApproved: carData.approved,
          updateAt: new Date().getTime()
        };
        update(singleUserRef(auth.currentUser.uid),updateData);
      }
    })
  };
